//Roles
export const LS_USER_INFO: string = "UserInfo";
export const LS_USER_PHOTO: string = "UserPhoto";
export const ROLE_CA_END_USER: string = "Role 9 CA End User";
export const ROLE_CA_DATA_MANAGER: string = "Role 10 CA Data Manager";
export const ROLE_ESA_END_USER: string = "Role 11 ESA End User";
export const ROLE_FUNC_ADMIN: string = "Role 12 Functional Administrator";
export const ALL_ROLES: string[] = [ROLE_CA_END_USER, ROLE_CA_DATA_MANAGER, ROLE_ESA_END_USER, ROLE_FUNC_ADMIN];
export const VIEW_REQUESTS_ROLES: string[] = [ROLE_CA_END_USER, ROLE_ESA_END_USER];
export const SEARCH_POI_ROLES: string[] = [ROLE_CA_END_USER, ROLE_ESA_END_USER];
export const SEARCH_CONTACTS_ROLES: string[] = [ROLE_CA_END_USER, ROLE_ESA_END_USER];
export const REQ_FOR_INFO_ROLES: string[] = [ROLE_CA_END_USER, ROLE_ESA_END_USER];
export const NEW_REQ_FOR_INFO_ROLES: string[] = [ROLE_CA_END_USER];
export const CONF_SYS_DETAILS_ROLES: string[] = [ROLE_FUNC_ADMIN];
export const MANAGE_SYS_DATA_ROLES: string[] = [ROLE_CA_END_USER, ROLE_CA_DATA_MANAGER];
export const MANAGE_SYS_DATA_POI_LIST_ROLES: string[] = [ROLE_CA_DATA_MANAGER];
export const MANAGE_SYS_DATA_CA_CONTACT_LIST_ROLES: string[] = [ROLE_CA_END_USER];
export const BULK_DELETE_ASSESSMENTS_ROLES: string[] = [ROLE_CA_DATA_MANAGER];
export const CA_END_USER_ASSIGNMENT_ROLES: string[] = [ROLE_CA_DATA_MANAGER];

//Navigation
//View requests
export const NAV_KEY_VIEW_REQUESTS: string = "view-requests";
export const NAV_KEY_SEARCH_POI: string = "search-for-POI";
export const NAV_KEY_SEARCH_CONTACTS: string = "search-contacts";

//Configure system details
export const NAV_KEY_CONF_SYS_DETAILS: string = "configure-system-details";
export const NAV_KEY_EU_SEC_LEG: string = "eu-sec-leg-bases";
export const NAV_KEY_REMINDER: string = "reminder";
export const NAV_KEY_PERIODS: string = "periods";
export const NAV_KEY_POI_SEARCH_SCENARIOS: string = "poi-search-scenario";
export const NAV_KEY_FIELD_GUIDANCE: string = "field-guidance";
export const SUB_NAV_KEYS_CONF_SYS_DETAILS: string[] = [NAV_KEY_EU_SEC_LEG, NAV_KEY_REMINDER, NAV_KEY_PERIODS, NAV_KEY_POI_SEARCH_SCENARIOS, NAV_KEY_FIELD_GUIDANCE];

//Manage system data
export const NAV_KEY_MANAGE_SYS_DATA: string = "manage-system-data";
export const NAV_KEY_POI_LIST: string = "poi-list";
export const NAV_KEY_CA_CONTACT_LIST: string = "ca-contact-list";
export const NAV_KEY_VIEW_UPLOADED_RECORDS_LIST: string = "view-uploaded-records";
export const NAV_KEY_VIEW_VALIDATION_RESULTS: string = "view-validation-results";
export const NAV_KEY_VIEW_EMAIL_CONFIGURATION: string = "email-configuration";
export const NAV_KEY_CA_END_USER_ASSIGNMENT: string = "eu-legal-basis-assignments";
export const SUB_NAV_KEYS_MANAGE_SYS_DATA: string[] = [NAV_KEY_POI_LIST, NAV_KEY_CA_END_USER_ASSIGNMENT];
export const NAV_KEY_BULK_DELETE_ASSESSMENTS: string = "bulk-delete-assessments";
//Sorting order
export const SORT_ORDER_ASC: string = "asc";
export const SORT_ORDER_DESC: string = "desc";

//PersonType
export const NATURAL_PERSON_TYPE: number = 0;
export const LEGAL_PERSON_TYPE: number = 1;

//ContactType
export const PERSON_CONTACT_TYPE: number = 2;
export const TEAM_CONTACT_TYPE: number = 1;
